import { registerKlvTooltip } from '@klaviyo-mkt/gatsby-components/atoms/klv-tooltip';
import { registerKlvModal } from '@klaviyo-mkt/gatsby-components/atoms/klv-modal';

export const onClientEntry = () => {
  registerKlvTooltip();
  registerKlvModal();
};

export { wrapPageElement } from './src/gatsby/wrap-page-element';
